import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMail = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 18 14",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M15.6666 0.333374H2.33329C1.41663 0.333374 0.674959 1.08337 0.674959 2.00004L0.666626 12C0.666626 12.9167 1.41663 13.6667 2.33329 13.6667H15.6666C16.5833 13.6667 17.3333 12.9167 17.3333 12V2.00004C17.3333 1.08337 16.5833 0.333374 15.6666 0.333374ZM15.3333 3.87504L9.44163 7.55837C9.17496 7.72504 8.82496 7.72504 8.55829 7.55837L2.66663 3.87504C2.45829 3.74171 2.33329 3.51671 2.33329 3.27504C2.33329 2.71671 2.94163 2.38337 3.41663 2.67504L8.99996 6.16671L14.5833 2.67504C15.0583 2.38337 15.6666 2.71671 15.6666 3.27504C15.6666 3.51671 15.5416 3.74171 15.3333 3.87504Z" })
});
export default SvgMail;
